// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { Modal } from '../'

import { EditForm } from './EditForm'


export class WithdrawalBatchAddEditModal extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    product: PropTypes.string,
    initiateOn: PropTypes.string,
    initiateWorkflowAt: PropTypes.string,
    onCancelClick: PropTypes.func.isRequired,
    onSaveClick: PropTypes.func.isRequired
  }

  static defaultProps = {
    title: 'Edit withdrawal batch'
  }

  render() {
    const { title, product, initiateOn, initiateWorkflowAt, onCancelClick, onSaveClick } = this.props

    return (
      <Modal
        heading={title}
        body={
          <EditForm
            product={product}
            initiateOn={initiateOn}
            initiateWorkflowAt={initiateWorkflowAt}
            onCancelClick={onCancelClick}
            onSaveClick={onSaveClick}
          />
        }
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-batch-add-edit-modal/index.js